module.exports = __webpack_public_path__ + "static/media/1POLICY15.5dae482d.jpg";